import React, { Component } from "react";
import {
    Column,
    DataGrid,
    Paging,
    Pager,
    HeaderFilter,
    FilterRow
} from 'devextreme-react/data-grid';
import { Format } from "devextreme-react/number-box";
import { Editing } from "devextreme-react/scheduler";
import PaginaToolbar from '../components/PaginaToolbar';
import { criarRegistrosBoletosDs } from "../DataSources";
import uiInfo from "../ui-info";
import UserInfo from "../UserInfo";

export default class RegistrarBoletosBox extends Component {
    constructor() {
        super();
        this._grid = React.createRef();
        this.dataSource = criarRegistrosBoletosDs();
    }

    render() {
        return (
            <React.Fragment>
                <div className={'content-block dx-card responsive-paddings'}>
                    <PaginaToolbar titulo="Gerar arquivo remessa">
                        <DataGrid
                            ref={grid => this._grid = grid}
                            dataSource={this.dataSource}
                            showBorders={true}
                            rowAlternationEnabled={true} remoteOperations={true} 
                            focusedRowEnabled={true}>
                            <Editing mode={"row"} allowAdding={false} allowUpdating={true} allowDeleting={true}  useIcons={true}/>
                            <Column dataField={'data'} caption={"Data"} dataType={"date"} format={uiInfo.formatoData.dataCurta} />
                            <Column dataField={'percentualPorDia'} caption={"% dia"} format={uiInfo.formatoNumerico.n2} />
                            <Column dataField={'limite'} caption={"% Máximo"} format={uiInfo.formatoNumerico.n2} />
                            <Paging defaultPageSize={20} />
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                                defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        </DataGrid>
                    </PaginaToolbar>
                </div>
            </React.Fragment>
        );
    }
}
